module.exports = __webpack_public_path__ + "static/media/logo.c6216dc0.png";